import { Component } from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { UserService } from '../../layout/service/user.service';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { EditorModule } from 'primeng/editor';

@Component({
    selector: 'app-section',
    imports: [
        TableModule,
        CommonModule,
        InputTextModule,
        ButtonModule,
        DialogModule,
        FormsModule,
        ToastModule,
        CheckboxModule,
        TagModule,
        InputGroupAddonModule,
        SelectModule,
        InputGroupModule,
        InputNumberModule,
        ToggleSwitchModule,
        EditorModule
    ],
    providers: [MessageService],
    template: `
        <p-toast />
        <div class="card">
            <div class="flex justify-between items-center">
                <h3 class="text-primary">Section Management</h3>
                <p-button severity="success" label="Add Section" (click)="addSection()" icon="pi pi-plus"></p-button>
            </div>
            <p-table #dt [value]="sections" stripedRows [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" [rows]="10"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [loading]="loading"
                [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [filterDelay]="0" [globalFilterFields]="['NAME_STASIUN']" [reorderableColumns]="true" (onRowReorder)="onRowReorder($event)">

                <ng-template pTemplate="caption">
                    <div class="flex justify-between items-center">
                        <div>
                            <input pInputText type="text" (input)="onInput($event, dt)" placeholder="Cari kata kunci" />
                        </div>
                    </div>
                </ng-template>

                <ng-template #header>
                    <tr>
                        <th style="width:3rem"></th>
                        <th>No</th>
                        <th>Nama</th>
                        <th>Kategori</th>
                        <th>Timer</th>
                        <th class="w-40">Audio</th>
                        <th class="w-60">Aksi</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-section let-i="rowIndex">
                    <tr [pReorderableRow]="i">
                        <td>
                            <span class="pi pi-sort" pReorderableRowHandle></span>
                        </td>
                        <td>{{ i + 1 }}</td>
                        <td>{{ section.NAME_STASIUN }}</td>
                            <td>
                                <ng-container *ngFor="let c of getCategories(section)">
                                    <p-tag [value]="c" [severity]="getCategorySeverity(c)" class="mr-2 mb-1"></p-tag>
                                </ng-container>
                            </td>
                            <td>
                                <div class="flex flex-wrap gap-2">
                                    <ng-container *ngFor="let t of getTimers(section)">
                                        <p-tag [value]="t.label + ': ' + t.minutes + 'm'" [severity]="t.severity"></p-tag>
                                    </ng-container>
                                </div>
                            </td>
                        <td>
                            <div class="flex gap-2">
                                <i *ngFor="let audio of parseAudioList(section.AUDIO_LIST); let idx = index"
                                   class="pi"
                                   [ngClass]="audio ? 'pi-check-circle text-success' : 'pi-times-circle text-danger'"
                                   [title]="audioNotifications[idx].label || 'Tidak diketahui'">
                                </i>
                            </div>
                        </td>
                        <td>
                            <p-button icon="pi pi-pencil" variant="text" [raised]="true" severity="warn" class="mr-2" (click)="openDialog('edit', section)"></p-button>
                            <p-button icon="pi pi-trash" variant="text" [raised]="true" severity="danger" class="mr-2" (click)="deleteSection(section)"></p-button>
                            <p-button icon="pi pi-bell" variant="text" [raised]="true" severity="info" class="mr-2" (click)="notifySection(section)"></p-button>
                            <p-button icon="pi pi-eye" variant="text" [raised]="true" severity="help" (click)="previewSoal(section)"></p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <p-dialog
            header="Ubah Seksi"
            [(visible)]="sectionDialog"
            [modal]="true"
            [style]="{ width: '70%' }"
            position="top"
            draggable="false">
            <span class="text-surface-500 dark:text-surface-400 block mb-8">
                Perbarui informasi seksi.
            </span>
            <div class="flex flex-col gap-2 mb-4">
                <label for="name" class="font-semibold w-24">Nama</label>
                <input pInputText [(ngModel)]="sectionName" id="name" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label class="font-semibold w-30">Kategori</label>
                <div class="flex flex-wrap gap-4">
                    <div *ngFor="let opt of categoryOptions" class="flex items-center">
                        <p-checkbox [inputId]="'cat-' + opt.value" [value]="opt.value" [(ngModel)]="sectionCategories"></p-checkbox>
                        <label [for]="'cat-' + opt.value" class="ml-2">{{ opt.label }}</label>
                    </div>
                </div>
            </div>
            <div *ngIf="sectionCategories?.includes('CUSTOM')" class="flex flex-col gap-2 mb-4">
                    <label for="sectionCustom" class="font-semibold w-30">Custom Kategori</label>
                <input pInputText [(ngModel)]="sectionCustom" id="sectionCustom" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="sectionTimer" class="font-semibold w-30">Waktu UKNPDPD</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="sectionTimer" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label class="font-semibold w-30">Waktu Preklinik</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="sectionTimerPreklinik" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label class="font-semibold w-30">Waktu Koas</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="sectionTimerKoas" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div *ngIf="sectionCategories?.includes('CUSTOM')" class="flex flex-col gap-2 mb-4">
                <label class="font-semibold w-30">Waktu Custom</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="sectionTimerCustom" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div class="flex flex-col gap-2 mb-4" *ngIf="!audioNotifications[4]?.enabled">
                <label for="sectionText" class="font-semibold w-30">Soal</label>
                <p-editor [(ngModel)]="sectionText" [style]="{ height: '320px' }" />
            </div>
            <ng-template #footer>
                <p-button label="Batal" [text]="true" severity="secondary" (click)="sectionDialog = false" />
                <p-button label="Simpan" [outlined]="true" severity="secondary" (click)="saveSection()" />
            </ng-template>
        </p-dialog>

        <p-dialog
            header="Tambah Seksi"
            [(visible)]="addSectionDialog"
            [modal]="true"
            [style]="{ width: '70%' }"
            position="top"
            draggable="false">
            <span class="text-surface-500 dark:text-surface-400 block mb-8">
                Tambahkan seksi baru.
            </span>
            <div class="flex flex-col gap-2 mb-4 w-full">
                <label for="newSectionName" class="font-semibold w-30">Nama Stasiun</label>
                <input pInputText [(ngModel)]="newSectionName" id="newSectionName" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label class="font-semibold w-30">Kategori</label>
                <div class="flex flex-wrap gap-4">
                    <div *ngFor="let opt of categoryOptions" class="flex items-center">
                        <p-checkbox [inputId]="'new-cat-' + opt.value" [value]="opt.value" [(ngModel)]="newSectionCategories"></p-checkbox>
                        <label [for]="'new-cat-' + opt.value" class="ml-2">{{ opt.label }}</label>
                    </div>
                </div>
            </div>
            <div *ngIf="newSectionCategories?.includes('CUSTOM')" class="flex flex-col gap-2 mb-4 w-full">
                <label for="newSectionCustom" class="font-semibold w-30">Custom Kategori</label>
                <input pInputText [(ngModel)]="newSectionCustom" id="newSectionCustom" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="newSectionTimer" class="font-semibold w-30">Waktu</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="newSectionTimer" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label class="font-semibold w-30">Waktu Preklinik</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="newSectionTimerPreklinik" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label class="font-semibold w-30">Waktu Koas</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="newSectionTimerKoas" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div *ngIf="newSectionCategories?.includes('CUSTOM')" class="flex flex-col gap-2 mb-4 w-full">
                <label class="font-semibold w-30">Waktu Custom</label>
                <p-inputgroup>
                    <p-inputnumber [(ngModel)]="newSectionTimerCustom" autocomplete="off" />
                    <p-inputgroup-addon>Menit</p-inputgroup-addon>
                </p-inputgroup>
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="newSectionText" class="font-semibold w-30">Soal</label>
                <p-editor [(ngModel)]="newSectionText" [style]="{ height: '320px' }" />
            </div>
            <ng-template #footer>
                <p-button label="Batal" [text]="true" severity="secondary" (click)="addSectionDialog = false" />
                <p-button label="Simpan" [outlined]="true" severity="secondary" (click)="saveNewSection()" />
            </ng-template>
        </p-dialog>

        <p-dialog
            header="Notifikasi Audio"
            [(visible)]="notificationDialog"
            [modal]="true"
            [style]="{ width: '35rem' }"
            position="top"
            draggable="false">
            <span class="text-surface-500 dark:text-surface-400 block mb-8">
                Kelola notifikasi audio untuk seksi ini.
            </span>
            <div class="flex flex-col gap-4">
                <div *ngFor="let audio of audioNotifications; let i = index" class="flex items-center justify-between">
                    <div class="flex items-center">
                        <i class="pi pi-volume-up mr-2"></i>
                        <span>{{ audio.label }}</span>
                    </div>
                    <p-toggleSwitch [(ngModel)]="audio.enabled" (onChange)="onToggleAudio(i + 1, audio.enabled)"></p-toggleSwitch>
                </div>
            </div>
            <ng-template #footer>
                <p-button label="Tutup" [text]="true" severity="secondary" (click)="notificationDialog = false" />
            </ng-template>
        </p-dialog>

        <p-dialog
            header="Preview Soal"
            [(visible)]="previewDialog"
            [modal]="true"
            [style]="{ width: '50rem' }"
            position="top"
            draggable="false">
            <div [innerHTML]="previewText"></div>
            <ng-template #footer>
                <p-button label="Tutup" [text]="true" severity="secondary" (click)="previewDialog = false" />
            </ng-template>
        </p-dialog>
    `
})
export class Section {
    constructor(
        private userService: UserService,
        private messageService: MessageService
    ) {}

    sections: any[] = [];
    loading: boolean = true;
    sectionDialog: boolean = false;
    sectionName: string = '';
    sectionTimer: number = 0;
    sectionTimerPreklinik: number = 0;
    sectionTimerKoas: number = 0;
    sectionTimerCustom: number = 0;
    sectionCategories: string[] = [];
    sectionText: string = '';
    dialogAction: 'add' | 'edit' = 'add';
    addSectionDialog: boolean = false;
    newSectionName: string = '';
    newSectionTimer: number = 0;
    newSectionTimerPreklinik: number = 0;
    newSectionTimerKoas: number = 0;
    newSectionTimerCustom: number = 0;
    newSectionCategories: string[] = [];
    newSectionText: string = '';
    previewDialog: boolean = false;
    previewText: string = '';
    // Category related
    categoryOptions = [
        { label: 'Preklinik', value: 'PREKLINIK' },
        { label: 'Koas', value: 'KOAS' },
        { label: 'UKNPDPD', value: 'UKNPDPD' },
        { label: 'Custom', value: 'CUSTOM' }
    ];
    sectionCategory: string = 'Preklinik';
    sectionCustom: string = '';
    newSectionCategory: string = 'Preklinik';
    newSectionCustom: string = '';
    currentUser: any = {};
    sectionId: string = '';
    notificationDialog: boolean = false;
    audioNotifications = [
        { label: 'Silahkan membaca soal!', enabled: false },
        { label: 'Silahkan masuk!', enabled: false },
        { label: 'Waktu kurang 5 menit!', enabled: false },
        { label: 'Waktu habis, Silakan lanjut station berikutnya!', enabled: false },
        { label: 'Waktu istirahat!', enabled: false }
    ];

    ngOnInit() {
        const userData = localStorage.getItem('user');
        this.currentUser = userData ? JSON.parse(userData) : null;

        const userId = this.currentUser?.ID_USER ?? this.currentUser?.ID ?? this.currentUser?.id ?? '';

        this.userService.getSections(userId).then((response) => {
            this.sections = response.data;
            this.loading = false;
        }).catch(() => {
            console.error('error');
            this.loading = false;
        });

        this.sectionId = '';
        this.sectionName = '';
        this.sectionTimer = 0;
        this.sectionTimerPreklinik = 0;
        this.sectionTimerKoas = 0;
        this.sectionTimerCustom = 0;
        this.sectionCategories = [];
        this.sectionCategory = 'Preklinik';
        this.sectionCustom = '';
        this.sectionText = '';
        this.newSectionCategories = [];
        this.newSectionCategory = 'Preklinik';
        this.newSectionCustom = '';
        this.newSectionTimer = 0;
        this.newSectionTimerPreklinik = 0;
        this.newSectionTimerKoas = 0;
        this.newSectionTimerCustom = 0;
        this.newSectionText = '';
    }

    onInput(event: Event, dt: Table) {
        const inputElement = event.target as HTMLInputElement;
        dt.filterGlobal(inputElement.value, 'contains');
    }

    openDialog(action: 'add' | 'edit', section: any = null) {
        this.dialogAction = action;
        this.sectionDialog = true;

        if (action === 'edit' && section) {
            this.sectionName = section.NAME_STASIUN;
            this.sectionTimer = section.TIMER / 60;
            this.sectionTimerPreklinik = (section.TIMER_PREKLINIK || section.TIMER_PRE || 0) / 60;
            this.sectionTimerKoas = (section.TIMER_KOAS || 0) / 60;
            this.sectionTimerCustom = (section.TIMER_CUSTOM || 0) / 60;
            // categories coming from API as array
            this.sectionCategories = Array.isArray(section.CATEGORY) ? section.CATEGORY : (section.CATEGORY ? [section.CATEGORY] : []);
            this.sectionId = section.ID;
            this.sectionText = section.SOAL || '';
            // Update audio notifications for this section
            const audioList = JSON.parse(section.AUDIO_LIST || '[]')[0] || {};
            this.audioNotifications = this.audioNotifications.map((audio, index) => ({
                ...audio,
                enabled: audioList[index + 1] || false
            }));
            // set category values if present
            const cat = section.CATEGORY || section.KATEGORI || section.CUSTOM_CATEGORY;
            if (section.CUSTOM_CATEGORY) {
                this.sectionCustom = section.CUSTOM_CATEGORY;
                if (!this.sectionCategories.includes('CUSTOM')) {
                    this.sectionCategories.push('CUSTOM');
                }
            }
            if (section.TIMER_CUSTOM) {
                this.sectionTimerCustom = section.TIMER_CUSTOM / 60;
            }
            if (cat && !this.sectionCategories.length) {
                this.sectionCategory = cat;
                this.sectionCustom = '';
            } else {
                this.sectionCategory = 'Preklinik';
                this.sectionCustom = '';
            }
        } else {
            this.sectionName = '';
            this.sectionTimer = 0;
            this.sectionTimerPreklinik = 0;
            this.sectionTimerKoas = 0;
            this.sectionTimerCustom = 0;
            this.sectionId = '';
            this.sectionCategories = [];
            this.sectionCategory = 'Preklinik';
            this.sectionCustom = '';
            this.sectionText = '';
        }
    }

    saveSection() {
        if (this.dialogAction === 'edit') {
            const categoryToSend = this.sectionCategories && this.sectionCategories.length ? this.sectionCategories : (this.sectionCategory === 'Custom' ? [this.sectionCustom] : [this.sectionCategory]);
            this.userService.updateSection(
                {
                    NAME_STASIUN: this.sectionName,
                    TIMER: this.sectionTimer * 60,
                    ID: this.sectionId,
                    CATEGORY: categoryToSend,
                    CUSTOM_CATEGORY: this.sectionCategories?.includes('CUSTOM') ? this.sectionCustom : null,
                    ID_USER: this.currentUser?.ID_USER ?? this.currentUser?.ID ?? this.currentUser?.id ?? null,
                    TIMER_PREKLINIK: this.sectionTimerPreklinik * 60,
                    TIMER_KOAS: this.sectionTimerKoas * 60,
                    TIMER_CUSTOM: this.sectionTimerCustom * 60,
                    SOAL: this.sectionText
                }
            ).then((response) => {
                this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Seksi berhasil diperbarui' });
                this.ngOnInit();
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal memperbarui seksi' });
            })
        }
        this.sectionDialog = false;
    }

    addSection() {
        this.addSectionDialog = true;
        this.newSectionName = '';
        this.newSectionTimer = 0;
        this.newSectionTimerPreklinik = 0;
        this.newSectionTimerKoas = 0;
        this.newSectionTimerCustom = 0;
        this.newSectionCategories = [];
        this.newSectionText = '';
    }

    saveNewSection() {
        this.userService.addSection(
            {
                NAME_STASIUN: this.newSectionName,
                TIMER: this.newSectionTimer * 60,
                CREATED_BY: this.currentUser.USERNAME,
                CATEGORY: this.newSectionCategories && this.newSectionCategories.length ? this.newSectionCategories : [this.newSectionCategory],
                CUSTOM_CATEGORY: this.newSectionCategories?.includes('CUSTOM') ? this.newSectionCustom : null,
                ID_USER: this.currentUser?.ID_USER ?? this.currentUser?.ID ?? this.currentUser?.id ?? null,
                TIMER_PREKLINIK: this.newSectionTimerPreklinik * 60,
                TIMER_KOAS: this.newSectionTimerKoas * 60,
                TIMER_CUSTOM: this.newSectionTimerCustom * 60,
                SOAL: this.newSectionText
            }
        ).then((response) => {
            this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Seksi berhasil ditambahkan' });
            this.ngOnInit();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal menambahkan seksi' });
        })
        this.addSectionDialog = false;
    }

    deleteSection(section: any) {
        this.userService.deleteSection(
            {
                ID: section.ID
            }
        ).then((response) => {
            this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Seksi berhasil dihapus' });
            this.ngOnInit();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal menghapus seksi' });
        })
    }

    notifySection(section: any) {

        this.sectionId = section.ID;
        const audioList = JSON.parse(section.AUDIO_LIST || '[]')[0] || {};
        this.audioNotifications = this.audioNotifications.map((audio, index) => ({
            ...audio,
            enabled: audioList[index + 1] || false
        }));

        this.notificationDialog = true;
    }

    onToggleAudio(audioIndex: number, enabled: boolean) {
        // Update the audioNotifications array
        this.audioNotifications[audioIndex - 1].enabled = enabled;

        // Update AUDIO_LIST in the backend
        const updatedAudioList = this.audioNotifications.reduce((acc:any, audio, index) => {
            acc[index + 1] = audio.enabled;
            return acc;
        }, {});

        this.userService.updateSection({
            ID: this.sectionId,
            AUDIO_LIST: [updatedAudioList],
            ID_USER: this.currentUser?.ID_USER ?? this.currentUser?.ID ?? this.currentUser?.id ?? null
        }).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Notifikasi audio berhasil diperbarui' });
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal memperbarui notifikasi audio' });
        });
    }

    previewSoal(section: any) {
        if (!section.SOAL) {
            if (this.isRestSection(section)) {
                this.previewText = 'Stasiun istirahat tidak memerlukan soal.';
            } else {
                this.previewText = 'Stasiun ini belum memiliki soal.';
            }
        } else {
            this.previewText = section.SOAL;
        }
        this.previewDialog = true;
    }

    isRestSection(section: any): boolean {
        const audioList = JSON.parse(section.AUDIO_LIST || '[]')[0] || {};
        return audioList[5] === true;
    }

    onRowReorder(event: any) {
        const updatePromises = this.sections.map((item: any, index: number) => {
            item.URUTAN = index + 1;
            return this.userService.updateSection({
            ID: item.ID,
            URUTAN: item.URUTAN,
            ID_USER: this.currentUser?.ID_USER ?? this.currentUser?.ID ?? this.currentUser?.id ?? null
            });
        });

        Promise.all(updatePromises)
            .then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Urutan seksi berhasil diperbarui'
                });
            })
            .catch(() => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: 'Gagal memperbarui urutan seksi'
                });
            });
    }


    parseAudioList(audioList: string): boolean[] {
        const parsedList = JSON.parse(audioList || '[]')[0] || {};
        return Object.keys(parsedList).map(key => parsedList[key]);
    }

    formatCategories(section: any): string {
        if (!section) return '-';
        if (Array.isArray(section.CATEGORY)) return section.CATEGORY.join(', ');
        return section.CATEGORY || section.KATEGORI || section.CUSTOM_CATEGORY || '-';
    }

    getCategories(section: any): string[] {
        if (!section) return [];
        if (Array.isArray(section.CATEGORY)) return section.CATEGORY;
        if (section.CATEGORY) return [section.CATEGORY];
        if (section.KATEGORI) return [section.KATEGORI];
        if (section.CUSTOM_CATEGORY) return [section.CUSTOM_CATEGORY];
        return [];
    }

    getCategorySeverity(cat: string): string {
        if (!cat) return 'secondary';
        const key = (cat || '').toString().toLowerCase();
        if (key.includes('ukm') || key.includes('UKNPDPD')) return 'info';
        if (key.includes('koas')) return 'warning';
        if (key.includes('preklinik')) return 'success';
        if (key.includes('custom')) return 'secondary';
        return 'secondary';
    }

    getTimers(section: any): Array<{ label: string; minutes: number; severity: string }> {
        const timers: Array<{ label: string; minutes: number; severity: string }> = [];
        if (!section) return timers;

        const push = (label: string, seconds: any, severity = 'info') => {
            const s = Number(seconds || 0);
            if (s > 0) timers.push({ label, minutes: Math.floor(s / 60), severity });
        };

        // default timer (TIMER) — treat as UKNPDPD/default
        push('UKNPDPD', section.TIMER, 'info');
        // category-specific
        push('Preklinik', section.TIMER_PREKLINIK || section.TIMER_PRE, 'success');
        push('Koas', section.TIMER_KOAS, 'warning');
        // user custom
        push('Custom', section.TIMER_CUSTOM, 'secondary');

        return timers;
    }
}